<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <span class="headline mb-0">{{ $t('M0010.title') }}</span>
      </v-card-title>

      <v-card-actions>
        <v-btn @click="search" class="btn-search" v-permit.SHARP_UAS_SEARCH>{{
          $t('app.buttons.search')
        }}</v-btn>
        <v-btn to="/m0011/new" v-permit.SHARP_UAS_EDIT>{{
          $t('app.buttons.new')
        }}</v-btn>
        <v-btn
          :disabled="selected.length != 1"
          @click="edit"
          v-permit.SHARP_UAS_NEW
          >{{ $t('app.buttons.edit') }}</v-btn
        >
        <v-btn @click="exportCsv" v-permit.SHARP_UAS_DOWNLOAD>{{
          $t('app.buttons.csvExport')
        }}</v-btn>
        <v-btn
          v-if="'UAC_101134' === this.$store.getters.user.id"
          @click="updateUserAccountId"
          >Update Account Id</v-btn
        >
        <v-btn
          @click="resetPassword"
          v-permit.SHARP_RESET_PASSWORD
          :disabled="selected.length !== 1"
          >RESET PASSWORD</v-btn
        >
      </v-card-actions>
    </v-card>

    <v-card class="mt-2">
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs3>
              <v-text-field
                clearable
                label="氏名CD"
                v-model.trim="query.code"
              />
            </v-flex>
            <v-flex xs3>
              <v-text-field
                clearable
                label="ユーザーID"
                v-model.trim="query.username"
              />
            </v-flex>
            <v-flex xs3>
              <v-text-field
                clearable
                label="氏名"
                v-model.trim="query.fullName"
              />
            </v-flex>
            <v-flex xs3>
              <v-text-field
                clearable
                label="英文氏名"
                v-model.trim="query.englishName"
              />
            </v-flex>
            <v-flex xs3>
              <v-text-field
                clearable
                label="Email"
                v-model.trim="query.email"
              />
            </v-flex>
            <v-flex xs3>
              <v-text-field
                clearable
                label="役職"
                v-model.trim="query.position"
              />
            </v-flex>
            <v-flex xs3>
              <v-text-field
                clearable
                label="外線電話番号"
                v-model.trim="query.outsideLineNumber"
              />
            </v-flex>
            <v-flex xs3>
              <v-text-field
                clearable
                label="内線電話番号"
                v-model.trim="query.insideLineNumber"
              />
            </v-flex>
            <v-flex xs3>
              <remote-autocomplete
                label="所属会社"
                url="companies/kv"
                v-model="query.companyId"
              />
            </v-flex>
            <v-flex xs3>
              <v-select
                :items="refused"
                clearable
                item-text="text"
                item-value="value"
                label="ログイン拒否"
                v-model="query.refused"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>

    <v-card class="mt-2">
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        class="elevation-0"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td :key="head.text" v-for="head in headers">
            {{ props.item[head.value] }}
          </td>
        </template>
      </v-data-table>
    </v-card>
    <update-password ref="pwd" />
  </v-container>
</template>
<script>
import md5 from 'md5'
import UpdatePassword from '../Pwd/ResetTargetPassword.vue'
export default {
  components: { UpdatePassword },
  methods: {
    resetPassword() {
      if(!this.selected[0].userAccountId){
        this.$message('', 'パスワードをリセットするには、先に「ログイン拒否」のチェックを外してください。', 'ERROR')
        return;
      }
      this.$refs.pwd.popup(this.selected[0].userAccountId)
    },
    exportCsv() {
      this.$http
        .get('/employees', {
          params: {
            ...this.query,
            page: 0,
            size: 999999,
            sort: [
              this.pagination.sortBy,
              this.pagination.descending ? 'desc' : 'asc',
            ].join(','),
          },
        })
        .then((res) => {
          console.log(res.data.content[0])
          this.$exportTable(
            res.data.content,
            this.headers.map((p) => p.value),
            this.headers.map((p) => p.text),
            'employee'
          )
        })
    },
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
        },
      }
    },
    load() {
      this.autoload = true
      this.loading = true
      this.$http
        .get('/employees', this.params())
        .then((res) => {
          this.pagination.page = res.data.number + 1
          this.pagination.rowsPerPage = res.data.size
          this.pagination.totalItems = res.data.totalElements
          this.results = res.data.content
          this.loading = false
          this.selected = []
        })
        .catch(() => {
          this.loading = false
        })
    },
    back() {
      this.$router.go(-1)
    },
    search() {
      this.pagination.page = 1
      this.$storeParams()
      this.load()
    },
    edit() {
      this.$router.push({
        path: 'M0011/edit',
        query: { id: this.selected[0].id },
      })
    },
    updateUserAccountId() {
      if (this.selected.length == 0) {
        this.loadUser().then((res) => this.updateUsers(res.data.content))
      } else {
        this.updateUsers(this.selected)
      }
    },
    updateUsers(users) {
      users.map((p) => {
        this.$http
          .post('/basic-data/user-accounts', {
            user_name: p.username,
            user_name_local: p.fullName,
            password: md5(p.username),
            locked_flag: p.loginRefused,
            password_expire_date: p.endDate,
          })
          .then((res) => {
            if (res.data.ret_code === '00000') {
              this.$http
                .put(
                  `/employees/update-account/${p.id}?userAccountId=${
                    res.data.addition_data.user_account_id
                  }`
                )
                .then(() => {
                  console.log('update user account id success:', p.username)
                })
            }
          })
      })
    },
    loadUser() {
      return this.$http.get('/employees', {
        params: {
          ...this.query,
          page: 0,
          size: 99999,
        },
      })
    },
  },
  mounted() {
    this.$loadParams()
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
  },
  data() {
    return {
      refused: [{ text: '是', value: true }, { text: '否', value: false }],
      loading: false,
      results: [],
      result: {},
      selected: [],
      outsideLineNumberItems: [],
      query: {
        code: '',
        username: '',
        fullname: '',
        englishName: '',
        email: '',
        insideLineNumber: '',
        outsideLineNumber: '',
        company: '',
        headerBusinessUnit: '',
        businessUnit: '',
        position: '',
      },
      pagination: {
        page: 1,
      },
      headers: [
        { text: '氏名CD', value: 'code', sortable: false },
        { text: 'ユーザーID', value: 'username', sortable: false },
        { text: '氏名', value: 'fullName', sortable: false },
        { text: '英文氏名', value: 'englishName', sortable: false },
        { text: 'Email', value: 'email', sortable: false },
        { text: '内線電話番号', value: 'insideLineNumber', sortable: false },
        { text: '外線電話番号', value: 'outsideLineNumber', sortable: false },
        { text: '所属会社', value: 'companyName', sortable: false },
        { text: '所属部署１', value: 'buName', sortable: false },
        { text: '所属部署２', value: 'departmentName', sortable: false },
        { text: '役職', value: 'position', sortable: false },
        { text: '権限', value: 'roles', sortable: false },
        { text: '適用開始日', value: 'startDate', sortable: false },
        { text: '適用終了日', value: 'endDate', sortable: false },
        { text: '最終Login日', value: 'lastLoginDate', sortable: false },
        { text: 'ログイン拒否', value: 'loginRefused', sortable: false },
      ],
      // { text: '利用状況', value: 'status', sortable: false }
    }
  },
}
</script>
